import { render } from "./ImportButton.vue?vue&type=template&id=3c59e036"
import script from "./ImportButton.vue?vue&type=script&lang=js"
export * from "./ImportButton.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__